import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const NotificationsTable = styled.div`
  width: 100%;
  border-top: 1px solid ${Color.Grey200};
`

export const MuteRow = styled.div`
  display: flex;
  padding: ${Spacing.S16} ${Spacing.S4};
  border-bottom: 1px solid ${Color.Grey200};
`
